import { render, staticRenderFns } from "./RecogSidebar.vue?vue&type=template&id=3e39c3b6&scoped=true&"
import script from "./RecogSidebar.vue?vue&type=script&lang=ts&"
export * from "./RecogSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./RecogSidebar.vue?vue&type=style&index=0&id=3e39c3b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e39c3b6",
  null
  
)

export default component.exports